import styled from 'styled-components'
import axios from "axios"
import { baseURL } from "../../services/authentication.js"
import {useSelector} from 'react-redux';
import Button from '@mui/material/Button';
import {useState} from 'react'
import CloudUploadIcon from '@mui/icons-material/CloudUpload';




const Container=styled.div`
	border: 1px solid grey;
	margin:25px;
	display:flex;
	flex-direction:column;
	align-items:center;
	padding:10px;
`;


const Seccion=styled.div`
	padding:15px;
	width:94%;
	display:flex;
	align-items:center;
	justify-content:space-around;
	background-color:#F7F6F6;
	margin:5px;
	border-radius:8px;
`;


export default function RutaTutorial(){

 	let rutas=useSelector(state=>state.dataRutas);
 	let tutoriales=useSelector(state=>state.data);
	let [send,setSend]=useState(true)

 	let allTutorials=[];

 	for (let clave in tutoriales){
 		for( let ele in tutoriales[clave]){

 			for( let tuto in tutoriales[clave][ele])
 		 	allTutorials.push(tutoriales[clave][ele][tuto])
 		}
    }


    let createPaso=async()=>{


				let idRutaPaso = document.getElementById("rutaPaso").value;
				let idTutoPaso=document.getElementById("tutorialPaso").value;
				let nroPaso=document.getElementById("nroPaso").value;
								
				const formPaso = new FormData();
				formPaso.append("ruta",idRutaPaso);
				formPaso.append("tutorial",idTutoPaso);
				formPaso.append("nroPaso",nroPaso);
			

				const datosCompletosPaso=Object.fromEntries(formPaso.entries());
			

				await axios.post(baseURL+'/rutas/paso',datosCompletosPaso)
			 	.then(res=>{alert("paso correctamente subido" )} )
			 	.catch((err) => (console.log(err)));

    }


 	return(
 		<Container>
 				<div>Crear pasos</div>
				<Seccion>	
					<label>Selecciona la ruta a agrgar pasos</label>
 					<select id="rutaPaso" disabled={send}>
 						<option value="" disabled selected>selecionar ruta</option>
 				 		{rutas.map(ruta=> <option key={ruta.ID+"ruta"} value={ruta.ID}>{ruta.name}</option> )}
 					</select>
				</Seccion>
				<Seccion>	
					<label>Selecciona el tutorial a Agregar a la ruta</label>
 					<select id="tutorialPaso" disabled={send}>
 						<option value="" disabled selected>selecionar tutorial</option>
 						{allTutorials.map(tuto=> <option key={tuto.ID+"tuto"} value={tuto.ID}>{tuto.name}</option> )}
 				 		
 					</select>
				</Seccion>
				<Seccion>
					<label>Digita el numero de paso</label>
					<input id="nroPaso" placeholder="nro de paso" disabled={send}></input>						
				</Seccion>	
					<Button variant="contained" loadingPosition="start"  sx={{marginBottom:"10px"}} startIcon={<CloudUploadIcon />} loading={send} onClick={createPaso} >subir</Button>
 		</Container>
 		)
}